<template>
  <div class="cost-management-container">
    <HomeHeader />
    <div class="w1200" id="main_content">
      <!-- 页头 -->
      <!-- <div class="page-header">
        <h1>成本加价管理</h1>
        <span class="page-subtitle">成本加价配置管理</span>
      </div> -->

      <div class="cost-management-content">
        <!-- 搜索区 -->
        <div class="filter-bar">
          <el-input v-model="filters.name" placeholder="名称" clearable style="width: 200px"
                    @keyup.enter="handleSearch" />
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset">重置</el-button>
          <div class="filter-spacer"></div>
          <el-button type="primary" @click="openCreate">+ 新增</el-button>
        </div>

        <!-- 列表 -->
        <div class="table-wrapper">
          <el-table :data="tableData" v-loading="listLoading" border stripe height="100%">
            <el-table-column label="序号" width="70" align="center">
              <template #default="{ $index }">
                {{ (filters.page - 1) * filters.page_size + $index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="name" label="名称" min-width="200" show-overflow-tooltip />
            <el-table-column prop="charge_type_display" label="计价方式" width="140" align="center" />
            <el-table-column prop="create_time" label="创建时间" width="200" align="center" />
            <el-table-column label="操作" width="200" align="center" fixed="right">
              <template #default="{ row }">
                <el-button type="primary" link @click="openDetail(row)">
                  <el-icon><View /></el-icon>详情
                </el-button>
                <el-button type="primary" link @click="openEdit(row)">
                  <el-icon><Edit /></el-icon>编辑
                </el-button>
                <el-button type="danger" link @click="handleDelete(row)">
                  <el-icon><Delete /></el-icon>删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="pagination-wrap">
          <el-pagination
            v-model:current-page="filters.page"
            v-model:page-size="filters.page_size"
            :page-sizes="[10, 20, 50, 100]"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="fetchList"
            @current-change="fetchList"
          />
        </div>
      </div>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog v-model="editVisible" :title="editForm.id ? '编辑成本加价' : '新增成本加价'"
               width="1180px" top="6vh" :close-on-click-modal="false" destroy-on-close>
      <div class="edit-form">
        <div class="form-row">
          <span class="form-label required">名称</span>
          <el-input v-model="editForm.name" placeholder="请输入策略名称" style="width: 320px" maxlength="200" />
        </div>
        <div class="form-row">
          <span class="form-label required">计价方式</span>
          <el-radio-group v-model="editForm.charge_type">
            <el-radio value="weight">按重量</el-radio>
            <el-radio value="volume">按体积</el-radio>
            <el-radio value="pieces">按件数</el-radio>
          </el-radio-group>
        </div>

        <div class="form-row rules-row">
          <span class="form-label">计费规则</span>
          <div class="rules-panel">
            <el-table :data="editForm.rules" border size="small">
              <el-table-column :label="`起始值(${valueUnit})`" min-width="120">
                <template #default="{ row }">
                  <el-input v-model="row.start_value" placeholder="0" />
                </template>
              </el-table-column>
              <el-table-column label="比较符" width="100">
                <template #default="{ row }">
                  <el-select v-model="row.start_operator" style="width: 100%">
                    <el-option v-for="op in operators" :key="op" :label="op" :value="op" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="类型" width="80" align="center">
                <template #default>
                  <span class="rule-type">{{ chargeTypeLabel }}</span>
                </template>
              </el-table-column>
              <el-table-column label="比较符" width="100">
                <template #default="{ row }">
                  <el-select v-model="row.end_operator" style="width: 100%">
                    <el-option v-for="op in operators" :key="op" :label="op" :value="op" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column :label="`结束值(${valueUnit})`" min-width="120">
                <template #default="{ row }">
                  <el-input v-model="row.end_value" placeholder="999999" />
                </template>
              </el-table-column>
              <el-table-column label="计价方式" width="150">
                <template #default="{ row }">
                  <el-select v-model="row.price_mode" style="width: 100%">
                    <el-option label="按单位加收" value="per_unit" />
                    <el-option label="固定加收" value="fixed" />
                    <el-option label="按百分比加收" value="percent" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="计价值" min-width="140">
                <template #default="{ row }">
                  <div class="value-with-unit">
                    <el-input v-model="row.price_value" placeholder="0" />
                    <span class="unit-suffix">{{ priceValueUnit(row.price_mode) }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="额外加收" min-width="140">
                <template #default="{ row }">
                  <div class="value-with-unit">
                    <el-input v-model="row.extra_fee" placeholder="0" />
                    <span class="unit-suffix">元/票</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="70" align="center">
                <template #default="{ $index }">
                  <el-button type="danger" link @click="removeRule($index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="add-rule-wrap">
              <el-button type="primary" size="small" @click="addRule">+ 添加区间</el-button>
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="handleSave">确定</el-button>
      </template>
    </el-dialog>

    <!-- 详情弹窗 -->
    <el-dialog v-model="detailVisible" title="成本加价详情" width="1000px" top="8vh">
      <div v-loading="detailLoading">
        <template v-if="detail">
          <el-descriptions :column="3" border class="detail-desc">
            <el-descriptions-item label="名称">{{ detail.name }}</el-descriptions-item>
            <el-descriptions-item label="计价方式">{{ detail.charge_type_display }}</el-descriptions-item>
            <el-descriptions-item label="创建时间">{{ detail.create_time }}</el-descriptions-item>
          </el-descriptions>
          <el-table :data="detail.rules" border size="small" class="detail-table">
            <el-table-column label="序号" type="index" width="60" align="center" />
            <el-table-column label="条件区间" min-width="220">
              <template #default="{ row }">
                {{ row.start_value }}{{ CHARGE_TYPE_UNITS[detail.charge_type]?.value }}
                {{ row.start_operator }} {{ CHARGE_TYPE_UNITS[detail.charge_type]?.label }}
                {{ row.end_operator }} {{ row.end_value }}{{ CHARGE_TYPE_UNITS[detail.charge_type]?.value }}
              </template>
            </el-table-column>
            <el-table-column label="计价方式" width="130" align="center">
              <template #default="{ row }">{{ priceModeDisplay(row.price_mode) }}</template>
            </el-table-column>
            <el-table-column label="计价值" width="140" align="center">
              <template #default="{ row }">{{ row.price_value }} {{ priceValueUnit(row.price_mode) }}</template>
            </el-table-column>
            <el-table-column label="额外加收" width="140" align="center">
              <template #default="{ row }">{{ row.extra_fee }} 元/票</template>
            </el-table-column>
          </el-table>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue'
import { View, Edit, Delete } from '@element-plus/icons-vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import HomeHeader from '@components/HomeHeader.vue'
import { postWlApi } from '@utils/api_v1.js'

const operators = ['>', '>=', '<', '<=']

const CHARGE_TYPE_UNITS = {
  weight: { value: 'kg', label: '重量' },
  volume: { value: 'm³', label: '体积' },
  pieces: { value: '件', label: '件数' }
}
const PRICE_MODE_DISPLAY = {
  per_unit: '按单位加收',
  fixed: '固定加收',
  percent: '按百分比加收'
}

// ---------- 列表 ----------
const filters = reactive({ name: '', page: 1, page_size: 20 })
const tableData = ref([])
const total = ref(0)
const listLoading = ref(false)

const fetchList = async () => {
  listLoading.value = true
  try {
    const res = await postWlApi('/cost_strategy/list', {
      name: filters.name,
      page: filters.page,
      page_size: filters.page_size
    })
    if (res && res.code === 0) {
      tableData.value = res.data.items || []
      total.value = res.data.total || 0
    } else {
      ElMessage.error(res?.message || '获取列表失败')
    }
  } catch (e) {
    console.error(e)
    ElMessage.error('获取列表失败')
  } finally {
    listLoading.value = false
  }
}

const handleSearch = () => {
  filters.page = 1
  fetchList()
}

const handleReset = () => {
  filters.name = ''
  filters.page = 1
  fetchList()
}

// ---------- 新增/编辑 ----------
const editVisible = ref(false)
const saving = ref(false)
const editForm = reactive({
  id: null,
  name: '',
  charge_type: 'weight',
  rules: []
})

const valueUnit = computed(() => CHARGE_TYPE_UNITS[editForm.charge_type]?.value || '')
const chargeTypeLabel = computed(() => CHARGE_TYPE_UNITS[editForm.charge_type]?.label || '')

const priceValueUnit = (mode) => {
  if (mode === 'per_unit') return '元/单位'
  if (mode === 'percent') return '%'
  return '元'
}
const priceModeDisplay = (mode) => PRICE_MODE_DISPLAY[mode] || mode

const emptyRule = () => ({
  start_value: '0',
  start_operator: '<',
  end_value: '999999',
  end_operator: '<=',
  price_mode: 'per_unit',
  price_value: '',
  extra_fee: ''
})

const openCreate = () => {
  editForm.id = null
  editForm.name = ''
  editForm.charge_type = 'weight'
  editForm.rules = [emptyRule()]
  editVisible.value = true
}

const openEdit = async (row) => {
  const res = await fetchDetail(row.id)
  if (!res) return
  editForm.id = res.id
  editForm.name = res.name
  editForm.charge_type = res.charge_type
  editForm.rules = (res.rules || []).map(r => ({
    start_value: r.start_value,
    start_operator: r.start_operator,
    end_value: r.end_value,
    end_operator: r.end_operator,
    price_mode: r.price_mode,
    price_value: r.price_value,
    extra_fee: r.extra_fee
  }))
  if (editForm.rules.length === 0) editForm.rules = [emptyRule()]
  editVisible.value = true
}

const addRule = () => {
  editForm.rules.push(emptyRule())
}

const removeRule = (index) => {
  editForm.rules.splice(index, 1)
}

const isNumber = (v) => v !== '' && v !== null && v !== undefined && !isNaN(Number(v))

// 将规则条件（起始值 op1 类型 op2 结束值）转换为计费量区间，null 表示无界
const ruleInterval = (r) => {
  const sv = Number(r.start_value)
  const ev = Number(r.end_value)
  let low = null, lowIncl = false, high = null, highIncl = false
  const mergeLow = (v, incl) => {
    if (low === null || v > low) { low = v; lowIncl = incl }
    else if (v === low) { lowIncl = lowIncl && incl }
  }
  const mergeHigh = (v, incl) => {
    if (high === null || v < high) { high = v; highIncl = incl }
    else if (v === high) { highIncl = highIncl && incl }
  }
  if (r.start_operator === '<') mergeLow(sv, false)
  else if (r.start_operator === '<=') mergeLow(sv, true)
  else if (r.start_operator === '>') mergeHigh(sv, false)
  else mergeHigh(sv, true)
  if (r.end_operator === '<') mergeHigh(ev, false)
  else if (r.end_operator === '<=') mergeHigh(ev, true)
  else if (r.end_operator === '>') mergeLow(ev, false)
  else mergeLow(ev, true)
  return { low, lowIncl, high, highIncl }
}

// 判断两个计费量区间是否存在重叠（重叠会导致同一计费量命中多条规则）
const intervalsOverlap = (a, b) => {
  let low, lowIncl, high, highIncl
  if (a.low === null) { low = b.low; lowIncl = b.lowIncl }
  else if (b.low === null) { low = a.low; lowIncl = a.lowIncl }
  else if (a.low > b.low) { low = a.low; lowIncl = a.lowIncl }
  else if (b.low > a.low) { low = b.low; lowIncl = b.lowIncl }
  else { low = a.low; lowIncl = a.lowIncl && b.lowIncl }
  if (a.high === null) { high = b.high; highIncl = b.highIncl }
  else if (b.high === null) { high = a.high; highIncl = a.highIncl }
  else if (a.high < b.high) { high = a.high; highIncl = a.highIncl }
  else if (b.high < a.high) { high = b.high; highIncl = b.highIncl }
  else { high = a.high; highIncl = a.highIncl && b.highIncl }
  if (low === null || high === null) return true
  if (low < high) return true
  if (low === high) return lowIncl && highIncl
  return false
}

const checkRuleConflicts = () => {
  const intervals = editForm.rules.map(ruleInterval)
  for (let i = 0; i < intervals.length; i++) {
    for (let j = i + 1; j < intervals.length; j++) {
      if (intervalsOverlap(intervals[i], intervals[j])) {
        ElMessage.warning(`第${i + 1}条与第${j + 1}条规则的计费区间存在重叠，会导致规则冲突`)
        return false
      }
    }
  }
  return true
}

const validateForm = () => {
  if (!editForm.name.trim()) {
    ElMessage.warning('请输入策略名称')
    return false
  }
  if (!editForm.charge_type) {
    ElMessage.warning('请选择计价方式')
    return false
  }
  if (editForm.rules.length === 0) {
    ElMessage.warning('计费规则至少需要一条')
    return false
  }
  for (let i = 0; i < editForm.rules.length; i++) {
    const r = editForm.rules[i]
    const no = i + 1
    if (!isNumber(r.start_value) || !isNumber(r.end_value)) {
      ElMessage.warning(`第${no}条规则的起始值/结束值必须为数字`)
      return false
    }
    if (!isNumber(r.price_value) || Number(r.price_value) < 0) {
      ElMessage.warning(`第${no}条规则的计价值必须为非负数字`)
      return false
    }
    if (r.extra_fee !== '' && (!isNumber(r.extra_fee) || Number(r.extra_fee) < 0)) {
      ElMessage.warning(`第${no}条规则的额外加收必须为非负数字`)
      return false
    }
  }
  return checkRuleConflicts()
}

const handleSave = async () => {
  if (!validateForm()) return
  const payload = {
    name: editForm.name.trim(),
    charge_type: editForm.charge_type,
    rules: editForm.rules.map(r => ({
      start_value: r.start_value,
      start_operator: r.start_operator,
      end_value: r.end_value,
      end_operator: r.end_operator,
      price_mode: r.price_mode,
      price_value: r.price_value,
      extra_fee: r.extra_fee === '' ? 0 : r.extra_fee
    }))
  }
  saving.value = true
  try {
    const url = editForm.id ? '/cost_strategy/update' : '/cost_strategy/create'
    if (editForm.id) payload.id = editForm.id
    const res = await postWlApi(url, payload)
    if (res && res.code === 0) {
      ElMessage.success(editForm.id ? '策略更新成功' : '策略创建成功')
      editVisible.value = false
      fetchList()
    } else {
      ElMessage.error(res?.message || '保存失败')
    }
  } catch (e) {
    console.error(e)
    ElMessage.error('保存失败')
  } finally {
    saving.value = false
  }
}

// ---------- 详情 ----------
const detailVisible = ref(false)
const detailLoading = ref(false)
const detail = ref(null)

const fetchDetail = async (id) => {
  detailLoading.value = true
  try {
    const res = await postWlApi('/cost_strategy/detail', { id })
    if (res && res.code === 0) {
      return res.data.strategy
    }
    ElMessage.error(res?.message || '获取详情失败')
    return null
  } catch (e) {
    console.error(e)
    ElMessage.error('获取详情失败')
    return null
  } finally {
    detailLoading.value = false
  }
}

const openDetail = async (row) => {
  detailVisible.value = true
  detail.value = null
  detail.value = await fetchDetail(row.id)
}

// ---------- 删除 ----------
const handleDelete = async (row) => {
  try {
    await ElMessageBox.confirm(`确定删除策略「${row.name}」吗？删除后不可恢复。`, '删除确认', {
      type: 'warning',
      confirmButtonText: '确定',
      cancelButtonText: '取消'
    })
  } catch {
    return
  }
  try {
    const res = await postWlApi('/cost_strategy/delete', { id: row.id })
    if (res && res.code === 0) {
      ElMessage.success('删除成功')
      fetchList()
    } else {
      ElMessage.error(res?.message || '删除失败')
    }
  } catch (e) {
    console.error(e)
    ElMessage.error('删除失败')
  }
}

onMounted(() => {
  fetchList()
})
</script>

<style scoped>
.cost-management-container {
  height: 100vh;
  overflow: hidden;
  background-color: #f5f7fa;
  display: flex;
  flex-direction: column;
}

#main_content.w1200 {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.page-header {
  flex-shrink: 0;
  display: flex;
  align-items: baseline;
  gap: 16px;
  padding: 16px 20px;
  margin-top: 20px;
  background: linear-gradient(90deg, #eaf3ff 0%, #f5f9ff 100%);
  border-radius: 8px;
}

.page-header h1 {
  font-size: 20px;
  margin: 0;
  color: #1d4ed8;
}

.page-subtitle {
  font-size: 13px;
  color: #606266;
}

.cost-management-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  margin-top: 16px;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.filter-bar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.filter-spacer {
  flex: 1;
}

.table-wrapper {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.pagination-wrap {
  flex-shrink: 0;
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

/* 编辑弹窗 */
.edit-form {
  padding: 0 4px;
}

.form-row {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.form-label {
  width: 70px;
  flex-shrink: 0;
  font-size: 14px;
  color: #606266;
}

.form-label.required::before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}

.rules-row {
  align-items: flex-start;
}

.rules-panel {
  flex: 1;
  min-width: 0;
  padding: 12px;
  background-color: #f7f9fc;
  border-radius: 6px;
}

.rule-type {
  font-weight: 600;
  color: #303133;
}

.value-with-unit {
  display: flex;
  align-items: center;
  gap: 4px;
}

.unit-suffix {
  flex-shrink: 0;
  font-size: 12px;
  color: #909399;
}

.add-rule-wrap {
  display: flex;
  justify-content: center;
  margin-top: 12px;
}

.detail-desc {
  margin-bottom: 16px;
}
</style>
